import { render } from "./CrudOrders.vue?vue&type=template&id=3f0d554e&scoped=true"
import script from "./CrudOrders.vue?vue&type=script&lang=js"
export * from "./CrudOrders.vue?vue&type=script&lang=js"

import "./CrudOrders.vue?vue&type=style&index=0&id=3f0d554e&lang=css"
import "./CrudOrders.vue?vue&type=style&index=1&id=3f0d554e&scoped=true&lang=postcss"

import exportComponent from "C:\\Users\\Bodnár Lajos\\Documents\\Work\\Vue.JS\\otthonapolo2020-FE-V3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f0d554e"]])

export default __exports__